import {DigitalPageItem} from '../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Paid,
  Title: 'Hello!',
  ProductCode: 'etg45',
  Description:
    'Here\'s all the online content included with your <strong>English Literature Text Guide</strong>.',
  Credits:
    '<i>Clipart from Corel®<br>Text, design, layout and original illustrations © Coordination Group Publications Ltd. (CGP) 2026. All rights reserved.</i>',};